// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AccountProvisionPolicyTest } from "./policy";
import type { TestAccountProvisionPolicyResponse } from "./policy";
import type { TestAccountProvisionPolicyRequest } from "./policy";
import { PolicySearch } from "./policy";
import type { CountUsedByResponse } from "./policy";
import type { CountUsedByRequest } from "./policy";
import type { SearchPoliciesResponse } from "./policy";
import type { SearchPoliciesRequest } from "./policy";
import { PolicyValidate } from "./policy";
import type { EditorValidateResponse } from "./policy";
import type { EditorValidateRequest } from "./policy";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Policies } from "./policy";
import type { ListPolicyResponse } from "./policy";
import type { ListPoliciesRequest } from "./policy";
import type { DeletePolicyResponse } from "./policy";
import type { DeletePolicyRequest } from "./policy";
import type { UpdatePolicyResponse } from "./policy";
import type { UpdatePolicyRequest } from "./policy";
import type { GetPolicyResponse } from "./policy";
import type { GetPolicyRequest } from "./policy";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreatePolicyResponse } from "./policy";
import type { CreatePolicyRequest } from "./policy";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.policy.v1.Policies
 */
export interface IPoliciesClient {
    /**
     * Create a policy.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: CreatePolicyRequest, options?: RpcOptions): UnaryCall<CreatePolicyRequest, CreatePolicyResponse>;
    /**
     * Get a policy by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetPolicyRequest, options?: RpcOptions): UnaryCall<GetPolicyRequest, GetPolicyResponse>;
    /**
     * Update a policy by providing a policy object and an update mask.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdatePolicyRequest, options?: RpcOptions): UnaryCall<UpdatePolicyRequest, UpdatePolicyResponse>;
    /**
     * Delete a policy by ID.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeletePolicyRequest, options?: RpcOptions): UnaryCall<DeletePolicyRequest, DeletePolicyResponse>;
    /**
     * List policies.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListPoliciesRequest, options?: RpcOptions): UnaryCall<ListPoliciesRequest, ListPolicyResponse>;
}
/**
 * @generated from protobuf service c1.api.policy.v1.Policies
 */
export class PoliciesClient implements IPoliciesClient, ServiceInfo {
    typeName = Policies.typeName;
    methods = Policies.methods;
    options = Policies.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create a policy.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: CreatePolicyRequest, options?: RpcOptions): UnaryCall<CreatePolicyRequest, CreatePolicyResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePolicyRequest, CreatePolicyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a policy by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetPolicyRequest, options?: RpcOptions): UnaryCall<GetPolicyRequest, GetPolicyResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPolicyRequest, GetPolicyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a policy by providing a policy object and an update mask.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdatePolicyRequest, options?: RpcOptions): UnaryCall<UpdatePolicyRequest, UpdatePolicyResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePolicyRequest, UpdatePolicyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a policy by ID.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeletePolicyRequest, options?: RpcOptions): UnaryCall<DeletePolicyRequest, DeletePolicyResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePolicyRequest, DeletePolicyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List policies.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListPoliciesRequest, options?: RpcOptions): UnaryCall<ListPoliciesRequest, ListPolicyResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPoliciesRequest, ListPolicyResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.policy.v1.PolicyValidate
 */
export interface IPolicyValidateClient {
    /**
     * Validate policies
     *
     * @generated from protobuf rpc: ValidateCEL
     */
    validateCEL(input: EditorValidateRequest, options?: RpcOptions): UnaryCall<EditorValidateRequest, EditorValidateResponse>;
}
/**
 * @generated from protobuf service c1.api.policy.v1.PolicyValidate
 */
export class PolicyValidateClient implements IPolicyValidateClient, ServiceInfo {
    typeName = PolicyValidate.typeName;
    methods = PolicyValidate.methods;
    options = PolicyValidate.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Validate policies
     *
     * @generated from protobuf rpc: ValidateCEL
     */
    validateCEL(input: EditorValidateRequest, options?: RpcOptions): UnaryCall<EditorValidateRequest, EditorValidateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditorValidateRequest, EditorValidateResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.policy.v1.PolicySearch
 */
export interface IPolicySearchClient {
    /**
     * Search policies based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchPoliciesRequest, options?: RpcOptions): UnaryCall<SearchPoliciesRequest, SearchPoliciesResponse>;
    /**
     * @generated from protobuf rpc: CountUsedBy
     */
    countUsedBy(input: CountUsedByRequest, options?: RpcOptions): UnaryCall<CountUsedByRequest, CountUsedByResponse>;
}
/**
 * @generated from protobuf service c1.api.policy.v1.PolicySearch
 */
export class PolicySearchClient implements IPolicySearchClient, ServiceInfo {
    typeName = PolicySearch.typeName;
    methods = PolicySearch.methods;
    options = PolicySearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search policies based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchPoliciesRequest, options?: RpcOptions): UnaryCall<SearchPoliciesRequest, SearchPoliciesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchPoliciesRequest, SearchPoliciesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountUsedBy
     */
    countUsedBy(input: CountUsedByRequest, options?: RpcOptions): UnaryCall<CountUsedByRequest, CountUsedByResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountUsedByRequest, CountUsedByResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.policy.v1.AccountProvisionPolicyTest
 */
export interface IAccountProvisionPolicyTestClient {
    /**
     * @generated from protobuf rpc: Test
     */
    test(input: TestAccountProvisionPolicyRequest, options?: RpcOptions): UnaryCall<TestAccountProvisionPolicyRequest, TestAccountProvisionPolicyResponse>;
}
/**
 * @generated from protobuf service c1.api.policy.v1.AccountProvisionPolicyTest
 */
export class AccountProvisionPolicyTestClient implements IAccountProvisionPolicyTestClient, ServiceInfo {
    typeName = AccountProvisionPolicyTest.typeName;
    methods = AccountProvisionPolicyTest.methods;
    options = AccountProvisionPolicyTest.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Test
     */
    test(input: TestAccountProvisionPolicyRequest, options?: RpcOptions): UnaryCall<TestAccountProvisionPolicyRequest, TestAccountProvisionPolicyResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TestAccountProvisionPolicyRequest, TestAccountProvisionPolicyResponse>("unary", this._transport, method, opt, input);
    }
}
